export const formatValue = (value, { format, currency, language }) => {
  if (format === 'percent') {
    return new Intl.NumberFormat(language, { style: 'percent', minimumFractionDigits: 2 }).format(value / 100)
  }

  if (format === 'currency') {
    return new Intl.NumberFormat(language, { style: 'currency', currency: currency || 'EUR' }).format(value)
  }

  return new Intl.NumberFormat(language, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}
